var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    fill: "white",
    stroke: "#19323c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 26.25H15.75V23.625H18.375V26.25ZM18.375 21.875H15.75V21.8689C15.75 20.4251 15.75 19.1783 16.338 18.305C16.7954 17.7252 17.3647 17.2432 18.0119 16.8875C18.3041 16.7003 18.5798 16.5226 18.8116 16.338C19.309 15.953 19.6839 15.4319 19.8908 14.8379C20.0977 14.244 20.1277 13.6027 19.9771 12.992C19.741 12.4276 19.3172 11.9621 18.7773 11.6743C18.2374 11.3865 17.6147 11.294 17.0145 11.4126C16.4143 11.5312 15.8735 11.8535 15.4836 12.325C15.0937 12.7965 14.8787 13.3882 14.875 14H12.25C12.25 12.6076 12.8031 11.2723 13.7877 10.2877C14.7723 9.30315 16.1076 8.75002 17.5 8.75002C18.4887 8.74705 19.4584 9.02148 20.2989 9.54212C21.1394 10.0628 21.817 10.8087 22.2548 11.6953C22.6479 12.5986 22.7797 13.594 22.6353 14.5685C22.4908 15.543 22.0758 16.4574 21.4375 17.2078C21.0411 17.647 20.5975 18.039 20.1128 18.3776C19.6889 18.67 19.3022 19.0129 18.9613 19.3988C18.4793 20.129 18.2716 21.0063 18.375 21.875Z",
    fill: "#19323c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingCircle);
export default __webpack_public_path__ + "static/media/onboarding-circle.3e7a51ccc31d7f083330a7c831702c33.svg";
export { ForwardRef as ReactComponent };